import { Button, SuccessMessage } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ReconsentConnection } from './getReconsentConnections';
import { LinkedAccount } from '../../../ui/linkedAccount/LinkedAccount';

export const ExtendSuccess = ({
    connection,
    onDone
}: {
    connection: ReconsentConnection;
    onDone: () => void;
}) => {
    return (
        <div className="space-y-l">
            <SuccessMessage size="medium">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.extend_success_heading"
                    defaultMessage="All set – we’ve extended your connection"
                />
            </SuccessMessage>

            <LinkedAccount account={connection} />

            <Button
                variant="primary-rounded"
                className="w-full"
                onClick={onDone}
            >
                <FormattedMessage
                    id="_.bank_selection_modal.done"
                    defaultMessage="Done"
                />
            </Button>
        </div>
    );
};
